import React, { useEffect, useState } from "react";
import { CiEdit } from "react-icons/ci";
import { GoTrash } from "react-icons/go";
import { BsArrowLeft } from "react-icons/bs";
import "./View.scss";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DeleteModal from "../../Model/DeleteModal";
import { toast } from "react-toastify";
import { HttpService } from "../../../service/HttpService";
import FullScreenLoader from "../../Loader/FullScreenLoader";
import { useAuth } from "../../../context/AuthProvider";
import { Decryption, Encryption } from "../../../Mixin/EncryptDecryptId";
import AddEditSchedule from "../AddForm/AddEditSchedule";
import AssignSchedule from "../AddForm/AssignSchedule";
import dayjs from "dayjs";
import { DataGrid, GridMoreVertIcon } from "@mui/x-data-grid";
import {
  IconButton,
  Popover,
  MenuItem,
  Badge,
  styled,
  Chip,
  Modal,
} from "@mui/material";
import { HiOutlineEye } from "react-icons/hi2";
import DownloadButton from "../../DownloadButton";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isBetween from "dayjs/plugin/isBetween";
import { is } from "date-fns/locale";
import { set } from "lodash";
import { RxCross1 } from "react-icons/rx";
import { TbAlertHexagonFilled } from "react-icons/tb";
import RockwoolSchedule from "../AddForm/RockwoolSchedule";
import PlantingAssignModal from "../AddForm/PlantingAssignModal";
import FullSwapModal from "../fullSwap/fullswapmodal";
import AddbackModal from "../fullSwap/AddbackModal";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);

const CustomBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#ffae00",
    color: "white",
  },
}));

const SopsView = () => {
  const params = useParams();
  const { id } = params || {};
  const [schedule, setSchedule] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [assignModalOpen, setAssignModalOpen] = React.useState(false);
  const [rockwoolModalOpen, setRockwoolModalOpen] = React.useState(false);
  const [fullSwapModalOpen, setFullSwapModalOpen] = React.useState(false);
  const [fullSwapAddbackModal, setfullSwapAddbackModal] = React.useState(false);

  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [taskId, setTaskId] = useState(null);
  const [DeleteSchedule, setDeleteSchedule] = useState(false);
  const [loading, setLoading] = useState(false);
  // planting modal state
  const [openPlantingAssign, setOpenPlantingAssign] = useState(false);
  const [selectedPlantingTask, setSelectedPlantingTask] = useState(null);
  const navigate = useNavigate();
  const { setShowLoginPopup, showLoginPopup } = useAuth();
  const httpService = new HttpService(setShowLoginPopup);
  const decryptedId = id && Decryption(id);
  const [anchorEl, setAnchorEl] = useState(null);
  const [dataId, setDataId] = useState();
  const [searchData, setSearchData] = useState([]);
  const location = useLocation();
  const [pageSize, setPageSize] = useState(15);
  const [rowCount, setRowCount] = useState("");
  const [page, setPage] = useState(0);
  const [scheduleID, setScheduleId] = useState("");
  const [scheduleTaskId, setScheduleTaskId] = useState("");
  const [isModalAlert, setIsModalAlert] = useState(false);
  const closeAlertModal = () => setIsModalAlert(false);
  const schedule_tasks_id = location?.state?.schedule_task_id;
  const filterStartDate = location?.state?.filterBydate?.start_date;
  const filterEndDate = location?.state?.filterBydate?.end_date;

  const fetchSchedule = async () => {
    setLoading(true);

    try {
      const baseUrl = location?.state?.isMilestone
        ? "schedule/get_milestone"
        : "schedule/get_schedule";

      // let url = `${baseUrl}/${decryptedId}?page=${
      //   page + 1
      // }&pageSize=${pageSize}`;
      let url = `${baseUrl}/${decryptedId}${location?.state?.isMilestone ? `?page=${page + 1}&pageSize=${pageSize}` : '' }`;

      if (filterStartDate) {
        url += `&start_date=${filterStartDate}`;
      }
      if (filterEndDate) {
        url += `&end_date=${filterEndDate}`;
      }
      const response = await httpService.get(url);
      if (response && response?.data && response?.data?.schedules?.length > 0) {
        setSchedule(response?.data);
        setSearchData(response?.data?.schedules);
        setScheduleId(response?.data?.id);
        // const responseData = response?.data?.schedules || [];
        // const dateFilter = location?.state?.filterBydate;
        // handleDataByDate(responseData, dateFilter);

        setRowCount(response?.data?.pagination?.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching schedule:", error);
    } finally {
      setTimeout(() => setLoading(false), 300);
    }
  };

  useEffect(() => {
    fetchSchedule();
  }, [id, showLoginPopup, page, pageSize]);

  const handleOpen = (id = null) => {
    setOpen(true);
    handleCloseMenu();
    if (id) {
      setScheduleTaskId(id);
    }
    fetchSchedule();
  };

  const handleClose = () => {
    setOpen(false);
    setAssignModalOpen(false);
    setRockwoolModalOpen(false);
    setFullSwapModalOpen(false);
    setfullSwapAddbackModal(false);
    setDeleteSchedule(false);
    fetchSchedule();
  };

  const HandleDeleteSchedule = async () => {
    try {
      let response = await httpService.delete(
        `${"schedule/delete_schedule"}/${decryptedId}`,
      );
      navigate("/schedule");
      if (response?.success === true) {
        toast.success("Schedule Deleted successfully", {
          position: "top-right",
        });
        setDeleteSchedule(false);
      }
    } catch (error) {
      setDeleteSchedule(false);
    }
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const viewPage = (id, task_id, type) => {
    const urlEncodedId = Encryption(id);
    const urlEncodeTaskId = Encryption(task_id);
    navigate(`/schedule/taskview/${urlEncodedId}`, {
      state: {
        prev_id: decryptedId,
        from: location.state?.from,
        task_id: urlEncodeTaskId,
        task_type: type,
      },
    });
  };

  // const handleDataByDate = (responseData, dateFilter) => {
  //   if (location?.state?.filterBydate) {
  //     const filter = location.state.filterBydate; // "all" | "today" | "currentMonth" | "range"
  //     let filteredData = [];

  //     if (filter.selectedOption === "Today") {
  //       filteredData = responseData.filter((item) =>
  //         dayjs().isSame(dayjs(item.start_date), "day")
  //       );
  //     } else if (filter.selectedOption === "all") {
  //       const startOfMonth = dayjs().startOf("month");
  //       const endOfMonth = dayjs().endOf("month");

  //       filteredData = responseData.filter((item) => {
  //         const start = dayjs(item.start_date);
  //         const end = dayjs(item.end_date);

  //         // keep if task overlaps with current month
  //         return (
  //           (start.isSameOrAfter(startOfMonth, "day") &&
  //             start.isSameOrBefore(endOfMonth, "day")) ||
  //           (end.isSameOrAfter(startOfMonth, "day") &&
  //             end.isSameOrBefore(endOfMonth, "day")) ||
  //           (start.isBefore(startOfMonth, "day") &&
  //             end.isAfter(endOfMonth, "day")) // spans entire month
  //         );
  //       });
  //     } else if (filter.selectedOption === "Date_Range") {
  //       const { start_date, end_date } = filter;

  //       filteredData = responseData.filter((item) =>
  //         dayjs(item.start_date).isBetween(
  //           dayjs(start_date, "MM-DD-YYYY"),
  //           dayjs(end_date, "MM-DD-YYYY"),
  //           "day",
  //           "[]"
  //         )
  //       );
  //     } else if (filter.selectedOption === "This_Week") {
  //       const { start_date, end_date } = filter;

  //       filteredData = responseData.filter((item) =>
  //         dayjs(item.start_date).isBetween(
  //           dayjs(start_date, "MM-DD-YYYY"),
  //           dayjs(end_date, "MM-DD-YYYY"),
  //           "day",
  //           "[]"
  //         )
  //       );
  //     } else {
  //       filteredData = responseData; // fallback → no filter
  //     }
  //     return setSearchData(filteredData);
  //   } else {
  //     // no filter in location.state → show all
  //     return setSearchData(responseData);
  //   }
  // };

  // const searchSchedules = (searchTerm) => {
  //   const searchTermLowerCase = searchTerm.toLowerCase();
  //   console.log("ttt -=-=",searchTermLowerCase,schedule)
  //   const results =
  //   schedule?.schedules?.length > 0 &&
  //   schedule?.schedules?.filter((item) => {
  //     for (let key in item) {
  //       if (
  //         typeof item[key] === "string" &&
  //         item[key].toLowerCase().includes(searchTermLowerCase)
  //       ) {
  //         return true;
  //       }
  //     }
  //     return false;
  //   });
  //   if (results) {
  //     setSearchData(results);
  //   }
  // };
  //   const searchSchedules = (searchTerm) => {
  //     const searchTermLowerCase = searchTerm.toLowerCase();
  //     console.log("Searching for term:", searchTermLowerCase, schedule);

  //     const results = schedule?.schedules?.length > 0 &&
  //         schedule.schedules.filter((item) => {
  //             return item?.milestone_name?.toLowerCase()?.includes(searchTermLowerCase) ||
  //                    item?.activity_name?.toLowerCase()?.includes(searchTermLowerCase) ||
  //                    item?.task_name?.toLowerCase()?.includes(searchTermLowerCase)||
  //                    item?.start_date?.toLowerCase()?.includes(searchTermLowerCase)||
  //                    item?.end_date?.toLowerCase()?.includes(searchTermLowerCase);

  //         });

  //     if (results) {
  //         setSearchData(results);
  //     }
  // };
  const searchSchedules = (searchTerm) => {
    const searchTermLowerCase = searchTerm.toLowerCase();
    // console.log("Searching for term:", searchTermLowerCase, schedule);

    const results =
      schedule?.schedules?.length > 0 &&
      schedule.schedules.filter((item) => {
        const matchesMilestone = item?.milestone_name
          .toLowerCase()
          .includes(searchTermLowerCase);
        const matchesActivity = item?.activity_name
          .toLowerCase()
          .includes(searchTermLowerCase);
        const matchesTask = item?.task_name
          .toLowerCase()
          .includes(searchTermLowerCase);
        const matchstartdate = item?.start_date
          ?.toLowerCase()
          ?.includes(searchTermLowerCase);
        const matchenddate = item?.end_date
          ?.toLowerCase()
          ?.includes(searchTermLowerCase);
        const matchesEmployee = item?.selected_employees?.some((employee) =>
          employee.name.toLowerCase().includes(searchTermLowerCase),
        );
        return (
          matchesMilestone ||
          matchesActivity ||
          matchesTask ||
          matchesEmployee ||
          matchstartdate ||
          matchenddate
        );
      });

    if (results) {
      setSearchData(results);
    }
  };

  const handleBackClick = () => {
    if (location.state?.from && location.state?.from !== "scheduleModule") {
      navigate(`/${location.state?.from}`);
    } else {
      navigate("/schedule"); // Default to task module if origin is unknown
    }
  };

  const assignMotherTask = () => {
    setSelectedSchedule(schedule_tasks_id);
    setAssignModalOpen(true);
  };

  useEffect(() => {
    if (schedule_tasks_id) {
      setIsModalAlert(true);
    }
  }, []);

  return (
    <>
      {loading && <FullScreenLoader />}
      <div className="maintenance-view">
        {location && location?.state?.from === "graph" && (
          <div className="page-title">
            <div className="title-wrap">
              <h1>Task Tracker</h1>
            </div>
          </div>
        )}
        {location && location?.state?.from !== "graph" && (
          <div className="page-title">
            <div className="title-wrap">
              <h1>
                <span className="back">
                  <BsArrowLeft onClick={() => handleBackClick()} />
                </span>
                Schedule Details - [{schedule?.name ? schedule?.name : "--"}]
              </h1>
            </div>
            <div className="button-wrap view-responsive">
              <button
                type="submit"
                className="btn btn-edit"
                onClick={() => {
                  handleOpen();
                }}
              >
                <CiEdit /> Edit{" "}
              </button>
              <button
                type="submit"
                className="btn btn-delete"
                onClick={() => {
                  setDeleteSchedule(true);
                }}
              >
                <GoTrash /> Delete{" "}
              </button>
            </div>
          </div>
        )}
        <div>
          <div className="row">
            {/* <div className="col-md-2">
              <div>
                <img src={Milestone} alt="Maintenance img" />
              </div>
            </div> */}
            <div className="col-md-12">
              <div className="row">
                {location && location?.state?.from !== "graph" && (
                  <>
                    <div className="col-md-2">
                      <div className="d-flex justify-content-md-between">
                        <label>Schedule Name </label>
                        <span>:</span>
                      </div>
                    </div>
                    <div className="col-md-10">
                      <p>{schedule?.name ? schedule?.name : "--"}</p>
                    </div>
                    <div className="col-md-2">
                      <div className="d-flex justify-content-md-between">
                        <label>Schedule Option </label>
                        <span>:</span>
                      </div>
                    </div>
                    <div className="col-md-10">
                      <p>
                        {schedule?.type ? (schedule?.type).toUpperCase() : "--"}
                      </p>
                    </div>
                    <div className="col-md-2">
                      <div className="d-flex justify-content-md-between">
                        <label>Start Date</label>
                        <span>:</span>
                      </div>
                    </div>
                    <div className="col-md-10">
                      <p>
                        {schedule?.adjusted_start_date
                          ? dayjs(schedule?.adjusted_start_date).format(
                              "MMM/DD/YYYY hh:mm A",
                            )
                          : "--"}
                      </p>
                    </div>
                    <div className="col-md-2">
                      <div className="d-flex justify-content-md-between">
                        <label>End Date</label>
                        <span>:</span>
                      </div>
                    </div>
                    <div className="col-md-10">
                      <p>
                        {schedule?.adjusted_end_date
                          ? dayjs(schedule?.adjusted_end_date).format(
                              "MMM/DD/YYYY hh:mm A",
                            )
                          : "--"}
                      </p>
                    </div>
                    <div className="col-md-2 mb-md-4">
                      <div className="d-flex justify-content-md-between">
                        <label>Plant Name</label>
                        <span>:</span>
                      </div>
                    </div>
                    <div className="col-md-10 mb-3">
                      <div className="milestone-list-wrap">
                        <span>
                          {schedule?.plant_name_alias
                            ? schedule?.plant_name_alias
                            : schedule?.plant_name
                              ? schedule?.plant_name
                              : "--"}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-2 mb-md-4">
                      <div className="d-flex justify-content-md-between">
                        <label>Room Name</label>
                        <span>:</span>
                      </div>
                    </div>
                    <div className="col-md-10 mb-3">
                      <div className="milestone-list-wrap">
                        <span>
                          {schedule?.room_name_alias
                            ? schedule?.room_name_alias
                            : schedule?.room_name
                              ? schedule?.room_name
                              : "--"}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-2 mb-md-4">
                      <div className="d-flex justify-content-md-between">
                        <label>On-Going</label>
                        <span>:</span>
                      </div>
                    </div>
                    <div className="col-md-10 mb-3">
                      <p>{schedule?.ongoing ? "On-Going" : "--"}</p>
                    </div>
                    <div className="col-md-2 mb-md-4">
                      <div className="d-flex justify-content-md-between">
                        <label>Schedules</label>
                        <span>:</span>
                      </div>
                    </div>
                  </>
                )}
                <div
                  className={`${
                    location?.state?.from === "graph"
                      ? "col-md-12"
                      : "col-md-10"
                  } mb-3`}
                >
                  <div
                    className="table-filter-wrap"
                    style={{ justifyContent: "end" }}
                  >
                    <DownloadButton id={decryptedId} />
                    <div className="header_search-wrap">
                      <div className="header_search_bar common_content">
                        <div className="input-group input_group">
                          <button className="btn search-btn search_btn">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="15"
                              height="15"
                              viewBox="0 0 21 21"
                              fill="none"
                            >
                              <circle
                                cx="9.98856"
                                cy="9.98856"
                                r="8.98856"
                                stroke="#495057"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M16.2402 16.7071L19.7643 20.222"
                                stroke="#495057"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </button>
                          <input
                            type="search"
                            className="form-control form_control"
                            placeholder="Search..."
                            aria-label="Search"
                            onChange={(e) => searchSchedules(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div
                  style={{
                    height: `${
                      schedule?.schedules && schedule?.schedules?.length > 0
                        ? ""
                        : "200px"
                    }`,
                    width: "100%",
                  }}
                >
                  <DataGrid
                    rows={searchData ? searchData : []}
                    getRowId={(schedule) => schedule?.id} // Specify the custom row ID
                    getRowHeight={() => "auto"}
                    getRowClassName={(params) =>
                      params?.row?.extended_task
                        ? "highlight_row "
                        : params?.row?.conflicted_status
                          ? "highlight"
                          : ""
                    }
                    columns={[
                      {
                        field: "action",
                        headerName: "Action",
                        headerAlign: "center",
                        width: 80,
                        align: "center",
                        sortable: false,
                        disbableColumnMenu: true,
                        renderCell: (params) => (
                          <>
                            <div className="action_icon-weap">
                              <IconButton
                                onClick={(e) => {
                                  handleMenuClick(e);
                                  setDataId(params?.row?.id);
                                }}
                              >
                                <GridMoreVertIcon />
                              </IconButton>
                            </div>
                            {anchorEl && dataId === params?.row?.id && (
                              <Popover
                                className="popup-menu"
                                key={dataId}
                                open={Boolean(anchorEl)}
                                anchorEl={anchorEl}
                                onClose={handleCloseMenu}
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "right",
                                }}
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "right",
                                }}
                              >
                                <MenuItem
                                  onClick={() => {
                                    viewPage(
                                      dataId,
                                      params?.row?.task_id,
                                      params?.row?.task_type,
                                    );
                                  }}
                                  className="menu-list-items"
                                >
                                  <div className="menu-list-items-text">
                                    View
                                  </div>
                                  <HiOutlineEye style={{ cursor: "pointer" }} />
                                </MenuItem>
                                <MenuItem
                                  onClick={() => {
                                    handleOpen(params?.row?.schedule_id);
                                  }}
                                  className="menu-list-items"
                                >
                                  <div className="menu-list-items-text">
                                    Edit
                                  </div>
                                  <CiEdit style={{ cursor: "pointer" }} />
                                </MenuItem>
                              </Popover>
                            )}
                          </>
                        ),
                      },
                      ...(location?.state?.from === "graph"
                        ? [
                            {
                              field: "room_name",
                              headerName: "Room Name",
                              minWidth: 180,
                              flex: 1,
                              sortable: false,
                              disableColumnMenu: true,
                              valueGetter: (params) =>
                                params.row?.room_name ||
                                schedule?.room_name ||
                                "N/A",
                            },
                          ]
                        : []),
                      {
                        field: "name",
                        headerName: "Schedule Name",
                        minWidth: 180,
                        flex: 1,
                        sortable: false,
                        disbableColumnMenu: true,
                        renderCell: (params) => {
                          return (
                            <div>
                              {params.row.schedule_name
                                ? params.row.schedule_name
                                : schedule.name}
                            </div>
                          );
                        },
                      },
                      {
                        field: "milestone_name",
                        headerName: "Milestone Name",
                        minWidth: 180,
                        flex: 1,
                        sortable: false,
                        disbableColumnMenu: true,
                        renderCell: (params) => {
                          return (
                            <div>
                              {params.row.milestone_name
                                ? params.row.milestone_name
                                : "--"}
                            </div>
                          );
                        },
                      },
                      {
                        field: "activity_name",
                        headerName: "Activity Name",
                        minWidth: 180,
                        flex: 1,
                        sortable: false,
                        disbableColumnMenu: true,
                        renderCell: (params) => {
                          return (
                            <div>
                              {params.row.activity_name
                                ? params.row.activity_name
                                : "--"}
                            </div>
                          );
                        },
                      },
                      {
                        field: "task_name",
                        headerName: "Task Name",
                        minWidth: 180,
                        flex: 1,
                        sortable: false,
                        disbableColumnMenu: true,
                        renderCell: (params) => {
                          return (
                            <div>
                              {params.row.task_name
                                ? params.row.task_name
                                : "--"}
                            </div>
                          );
                        },
                      },
                      {
                        field: "employees",
                        headerName: "Employees",
                        minWidth: 150,
                        flex: 1,
                        sortable: false,
                        disbableColumnMenu: true,
                        renderCell: (params) => {
                          const selectedEmployeeIds =
                            params.row.selected_employees;
                          const employees = params.row.employees || [];

                          // Filter employees whose IDs are in selectedEmployeeIds
                          // const selectedEmployees = employees.filter(
                          //   (employee) =>
                          //     selectedEmployeeIds.includes(employee.id)
                          // );
                          const selectedEmployees = employees.filter((item) => {
                            return selectedEmployeeIds?.some(
                              (selected) => selected.id === item.id,
                            );
                          });

                          // Extract the names of the selected employees
                          const employeeNames = selectedEmployees.map(
                            (employee) => employee.name,
                          );

                          return (
                            <div>
                              {employeeNames.length > 0
                                ? employeeNames.join(", ")
                                : "--"}
                            </div>
                          );
                        },
                      },
                      // ...(location?.state?.from !== "graph"
                      //   ? [
                      //       {
                      //         field: "assign",
                      //         headerName: "Assign",
                      //         headerAlign: "center",
                      //         align: "center",
                      //         minWidth: 100,
                      //         flex: 0.5,
                      //         sortable: false,
                      //         disbableColumnMenu: true,
                      //         renderCell: (params) => {
                      //           const taskName =
                      //             params.row.task_name?.toLowerCase();

                      //           if (
                      //             taskName !== "take clone" &&
                      //             taskName !== "take clones"
                      //           ) {
                      //             return null; // hide button if not matching
                      //           } else {
                      //             const handleAssign = () => {
                      //               setSelectedSchedule(params.row.id);
                      //               setAssignModalOpen(true);
                      //             };

                      //             const isDisabled =
                      //               params.row.job_completed === 1 ||
                      //               params.row.job_completed === 2 ||
                      //               params.row.job_completed === 6;

                      //             return (
                      //               <button
                      //                 className="assign-button normal-assign"
                      //                 onClick={handleAssign}
                      //                 disabled={isDisabled}
                      //                 style={{
                      //                   opacity: isDisabled ? 0.5 : 1,
                      //                   cursor: isDisabled
                      //                     ? "not-allowed"
                      //                     : "pointer",
                      //                 }}
                      //               >
                      //                 Assign
                      //               </button>
                      //             );
                      //           }
                      //         },
                      //       },
                      //     ]
                      //   : []),
                      ...(location?.state?.from !== "graph"
                        ? [
                            {
                              field: "assign",
                              headerName: "Assign",
                              headerAlign: "center",
                              align: "center",
                              minWidth: 100,
                              flex: 0.5,
                              sortable: false,
                              disbableColumnMenu: true,
                              renderCell: (params) => {
                                const taskName = params.row.task_name;
                                const name = (taskName ?? "")
                                  .toLowerCase()
                                  .trim();

                                const isTakeClone =
                                  name === "take clone" ||
                                  name === "take clones";
                                const isRockwool = name.includes("rockwool"); // matches "rockwool-week 1", etc.
                                const isPlanting = name === "planting";
                                const isFullSwap =
                                  name === "full swap" ||
                                  name.includes("full swap") ||
                                  name.includes("fullswap") ||
                                  name.includes("nutrient");
                                // const isAddback =
                                //   name.includes("Add-back".toLowerCase()) ||
                                //   name.includes("Add back".toLowerCase()) ||
                                //   name.includes("Addback".toLowerCase());
                                const shouldRender =
                                  isTakeClone ||
                                  isRockwool ||
                                  isPlanting ||
                                  isFullSwap;
                                  // isAddback;

                                // const shouldRender = isTakeClone || isRockwool;
                                if (!shouldRender) return null;

                                const handleAssign = () => {
                                  setSelectedSchedule(params.row.id);
                                  setTaskId(params.row.task_id);
                                  if (isTakeClone) {
                                    setAssignModalOpen(true);
                                  } else if (isRockwool) {
                                    setRockwoolModalOpen(true);
                                  } else if (isPlanting) {
                                    setSelectedPlantingTask({
                                      schedule,
                                      ...params.row,
                                    });
                                    setOpenPlantingAssign(true);
                                  } else if (isFullSwap) {
                                    setSelectedPlantingTask(params.row);
                                    setFullSwapModalOpen(true);
                                  } 
                                  // else if (isAddback) {
                                  //   setSelectedPlantingTask(params.row);
                                  //   setfullSwapAddbackModal(true);
                                  // }
                                };

                                const isDisabled = [1, 2, 6].includes(
                                  params.row.job_completed,
                                );

                                return (
                                  <button
                                    className={`assign-button ${
                                      isRockwool
                                        ? "rockwool-assign"
                                        : "normal-assign"
                                    }`}
                                    onClick={handleAssign}
                                    disabled={isDisabled}
                                    style={{
                                      opacity: isDisabled ? 0.5 : 1,
                                      cursor: isDisabled
                                        ? "not-allowed"
                                        : "pointer",
                                    }}
                                  >
                                    Assign
                                  </button>
                                );
                              },
                            },
                          ]
                        : []),
                      ...(location?.state?.from !== "graph"
                        ? [
                            {
                              field: "ongoing",
                              headerName: "On-Going Task",
                              headerAlign: "center",
                              align: "center",
                              minWidth: 150,
                              flex: 1,
                              sortable: false,
                              disbableColumnMenu: true,
                              renderCell: (params) => {
                                return (
                                  <div>
                                    {params.row.ongoing ? (
                                      <Chip
                                        label={`On-Going`}
                                        color="primary"
                                        variant="outlined"
                                      />
                                    ) : (
                                      "--"
                                    )}
                                  </div>
                                );
                              },
                            },
                          ]
                        : []),
                      {
                        field: "job_completed",
                        headerName: "Status",
                        headerAlign: "center",
                        align: "center",
                        minWidth: 150,
                        flex: 1,
                        sortable: false,
                        disbableColumnMenu: true,
                        renderCell: (params) => {
                          const jobCompleted = params.row.job_completed; // Assuming 'job_completed' is the field name

                          let status;
                          switch (jobCompleted) {
                            case 0:
                              switch (params?.row?.status) {
                                case 4:
                                  status = "To Do";
                                  break;
                                case 5:
                                  status = "Pending";
                                  break;
                                case 6:
                                  status = "Ongoing";
                                  break;
                              }
                              break;
                            case 1:
                              status = "Done";
                              break;
                            case 2:
                              status = "Approved";
                              break;
                            case 3:
                              status = "Rejected";
                              break;
                            default:
                              status = "Unknown";
                          }
                          // }

                          let statusBadge;
                          switch (status) {
                            case "Ongoing":
                              statusBadge = (
                                <CustomBadge
                                  badgeContent={"Ongoing"}
                                ></CustomBadge>
                              );
                              break;
                            case "To Do":
                              statusBadge = (
                                <Badge badgeContent={"To Do"} color="primary" />
                              );
                              break;
                            case "Pending":
                              statusBadge = (
                                <Badge
                                  badgeContent={"Pending"}
                                  color="secondary"
                                />
                              );
                              break;
                            case "Done":
                              statusBadge = (
                                <Badge badgeContent={"Done"} color="success" />
                              );
                              break;
                            case "Approved":
                              statusBadge = (
                                <Badge
                                  badgeContent={"Approved"}
                                  color="success"
                                />
                              );
                              break;
                            case "Rejected":
                              statusBadge = (
                                <Badge
                                  badgeContent={"Rejected"}
                                  color="error"
                                />
                              );
                              break;
                            default:
                              statusBadge = (
                                <Badge badgeContent={"Unknown"} color="error" />
                              );
                          }
                          return <div>{statusBadge}</div>;
                        },
                      },
                      {
                        field: "start_date",
                        headerName: "Start Date",
                        headerAlign: "center",
                        align: "center",
                        minWidth: 180,
                        flex: 1,
                        sortable: false,
                        disbableColumnMenu: true,
                        renderCell: (params) => {
                          return (
                            <div>
                              {dayjs(params.row.start_date).format(
                                "MMM/DD/YYYY",
                              )}
                            </div>
                          );
                        },
                      },
                      {
                        field: "end_date",
                        headerName: "End Date",
                        headerAlign: "center",
                        align: "center",
                        minWidth: 180,
                        flex: 1,
                        sortable: false,
                        disbableColumnMenu: true,
                        renderCell: (params) => {
                          return (
                            <div>
                              {dayjs(params.row.end_date).format("MMM/DD/YYYY")}
                            </div>
                          );
                        },
                      },
                      {
                        field: "cron_duration",
                        headerName: "Duration",
                        headerAlign: "center",
                        align: "center",
                        minWidth: 150,
                        flex: 1,
                        sortable: false,
                        disbableColumnMenu: true,
                        renderCell: (params) => {
                          return (
                            <div>
                              {params.row.cron_duration
                                ? params.row.cron_duration
                                    .charAt(0)
                                    .toUpperCase() +
                                  params.row.cron_duration.slice(1)
                                : "--"}
                            </div>
                          );
                        },
                      },
                      {
                        field: "cron_days",
                        headerName: "Week Days",
                        minWidth: 150,
                        flex: 1,
                        sortable: false,
                        disbableColumnMenu: true,
                        renderCell: (params) => {
                          return (
                            <div>
                              {params.row.cron_days?.length
                                ? params.row.cron_days
                                    .map(
                                      (day) =>
                                        day.charAt(0).toUpperCase() +
                                        day.slice(1),
                                    )
                                    .join(", ")
                                : "--"}
                            </div>
                          );
                        },
                      },
                      {
                        field: "cron_frequency",
                        headerName: "Frequency",
                        headerAlign: "center",
                        align: "center",
                        minWidth: 150,
                        flex: 1,
                        sortable: false,
                        disbableColumnMenu: true,
                        renderCell: (params) => {
                          return (
                            <div>
                              {params.row.cron_frequency
                                ? params.row.cron_frequency
                                : "--"}
                            </div>
                          );
                        },
                      },
                      // {
                      //   field: "cron_start_date",
                      //   headerName: "Cron Start Date",
                      //   headerAlign: "center",
                      //   align: "center",
                      //   minWidth: 180,
                      //   flex: 1,
                      //   sortable: false,
                      //   disbableColumnMenu: true,
                      //   renderCell: (params) => {
                      //     return (
                      //       <div>
                      //         {dayjs(params.row.cron_start_date).format(
                      //           "MMM D, YYYY"
                      //         )}
                      //       </div>
                      //     );
                      //   },
                      // },
                      // {
                      //   field: "cron_end_date",
                      //   headerName: "Cron End Date",
                      //   headerAlign: "center",
                      //   align: "center",
                      //   minWidth: 180,
                      //   flex: 1,
                      //   sortable: false,
                      //   disbableColumnMenu: true,
                      //   renderCell: (params) => {
                      //     return (
                      //       <div>
                      //         {dayjs(params.row.cron_end_date).format(
                      //           "MMM D, YYYY"
                      //         )}
                      //       </div>
                      //     );
                      //   },
                      // },
                    ]}
                    // initialState={{
                    //   pagination: {
                    //     rowCount: -1,
                    //   },
                    // }}
                    // paginationMode="server"
                    // sortingMode="server"
                    // rowCount={rowCount}
                    // pageSizeOptions={[15, 50, 100]}
                    // paginationModel={{ pageSize: pageSize, page: page }}
                    // onPaginationModelChange={(event) => {
                    //   setPage(event?.page);
                    //   setPageSize(event?.pageSize);
                    // }}
                    checkboxSelection={false}
                    rowSelection={false}
                    autoHeight
                    hideFooter
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {open && (
        <AddEditSchedule
          open={open}
          handleClose={() => handleClose()}
          schedule_id={
            location?.state?.isMilestone ? scheduleTaskId : decryptedId
          }
          isAdd={false}
          fetchScheduleData={() => fetchSchedule()}
        />
      )}

      {assignModalOpen && (
        <AssignSchedule
          open={assignModalOpen}
          handleClose={handleClose}
          schedule_task_id={selectedSchedule}
          fetchSchedule={fetchSchedule}
        />
      )}
      {rockwoolModalOpen && (
        <RockwoolSchedule
          open={rockwoolModalOpen}
          handleClose={handleClose}
          schedule_task_id={selectedSchedule}
          fetchSchedule={fetchSchedule}
        />
      )}
      {openPlantingAssign && (
        <PlantingAssignModal
          open={openPlantingAssign}
          onClose={() => setOpenPlantingAssign(false)}
          scheduleTask={selectedPlantingTask}
          onAssigned={() => {
            setOpenPlantingAssign(false);
            setSelectedPlantingTask(null);
            fetchSchedule();
          }}
        />
      )}
      {fullSwapModalOpen && (
        <FullSwapModal
          open={fullSwapModalOpen}
          onClose={() => setFullSwapModalOpen(false)}
          scheduleTaskId={selectedSchedule}
          taskId={taskId}
          rowData={selectedPlantingTask}
          onSave={() => {
            setFullSwapModalOpen(false);
            fetchSchedule();
          }}
        />
      )}
      {fullSwapAddbackModal && (
        <AddbackModal
          open={fullSwapAddbackModal}
          onClose={() => setfullSwapAddbackModal(false)}
          scheduleTaskId={selectedSchedule}
          taskId={taskId}
          rowData={selectedPlantingTask}
          onSave={() => {
            setfullSwapAddbackModal(false);
            fetchSchedule();
          }}
        />
      )}

      <DeleteModal
        open={DeleteSchedule}
        HandleClose={() => handleClose()}
        HandleDelete={() => HandleDeleteSchedule()}
      />

      {isModalAlert && (
        <Modal open={isModalAlert} onClose={() => closeAlertModal()}>
          <div
            className="modal_block"
            style={{ height: "212px", width: "587px" }}
          >
            <div
              className="modal_header"
              style={{ padding: "27px 36px 10px", marginBottom: "0px" }}
            >
              <div className="modal_title_wrapper">
                {/* <h2 className="modal_title">Are you Sure ?</h2> */}
              </div>
              <div className="cancel-btn-wrap">
                <RxCross1
                  onClick={() => closeAlertModal()}
                  style={{ width: "22px", height: "22px" }}
                />
              </div>
            </div>
            <div
              className="modal_content d-flex justify-content-center"
              style={{ height: "69px" }}
            >
              <div className="modal_content_inner">
                <div>
                  <TbAlertHexagonFilled />
                </div>
                <div>
                  <p>Please assign Mother Plant for Take Clone</p>
                </div>
              </div>
            </div>
            <div className="modal_footer">
              <button
                onClick={() => {
                  closeAlertModal();
                  assignMotherTask();
                }}
                className="btn btn-primary"
              >
                Okay
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default SopsView;
